module.exports = __webpack_public_path__ + "static/media/iPhone14-3.b56649f8.png";